import { formatPhoneForDisplay } from '@containers/crm/ActionCenter/format';

export const STAFF_TEXT_PHONE_REQUIRED_MESSAGE = 'Enter your cell phone number.';
export const STAFF_TEXT_PHONE_INVALID_MESSAGE = 'Enter a valid 10-digit phone number, like (555) 123-4567.';
export const STAFF_TEXT_SECTION_ID = 'staff-text';

const PHONE_INPUT = /^\+?[\d\s().-]+$/;
const DISALLOWED_PHONE_CHARS = /[^\d\s().+-]/g;
// Must match the server: US and Canadian numbers, area code and exchange cannot start with 0 or 1.
const NANP_DIGITS = /^[2-9]\d{2}[2-9]\d{6}$/;

export const formatStaffTextPhone = (phone?: string | null): string => (phone ? formatPhoneForDisplay(phone) : '');

/** Drops characters that cannot appear in a phone number, as the user types. */
export const sanitizePhoneInput = (value: string): string => value.replace(DISALLOWED_PHONE_CHARS, '');

/** E.164 for a US or Canadian number in any common format, otherwise null. */
export const toStaffTextPhoneE164 = (raw: string): string | null => {
  const value = (raw || '').trim();
  if (!PHONE_INPUT.test(value)) {
    return null;
  }

  let digits = value.replace(/\D/g, '');
  if (digits.length === 11 && digits.startsWith('1')) {
    digits = digits.slice(1);
  }

  return NANP_DIGITS.test(digits) ? `+1${digits}` : null;
};

export const getStaffTextPhoneError = (raw: string): string | null => {
  if (!(raw || '').trim()) {
    return STAFF_TEXT_PHONE_REQUIRED_MESSAGE;
  }

  return toStaffTextPhoneE164(raw) ? null : STAFF_TEXT_PHONE_INVALID_MESSAGE;
};

const escapeVCardText = (value: string): string => value.replace(/([\\;,])/g, '\\$1').replace(/\r?\n/g, '\\n');

/** A contact card, so scanning the QR code offers to save the agency number rather than just showing it. */
export const buildAgencyContactCard = (agencyName: string | null, textNumberE164: string): string => {
  const name = escapeVCardText(agencyName ? `${agencyName} Text a Photo` : 'Text a Photo');

  return [
    'BEGIN:VCARD',
    'VERSION:3.0',
    `N:${name};;;;`,
    `FN:${name}`,
    `TEL;TYPE=CELL:${textNumberE164}`,
    'END:VCARD',
  ].join('\r\n');
};
